import Skeleton from '@/shared/Loaders/Skeleton'
import cn from '@/utils/cn'
import css from '../reportTableContent.module.css'

interface IProps {
  days: Date[]
  index: number
  renderUsersCell?: boolean
}

const SkeletonContentRow = ({ renderUsersCell = true, ...props }: IProps) => {
  return (
    <div className={cn(css.row, css.contentRow)}>
      {renderUsersCell && (
        <div className={css.userCell} data-loading={true}>
          <Skeleton height="24px" width="24px" style={{ borderRadius: '50%' }} />
          <Skeleton
            height="20px"
            width={`calc(200px + ${props.index % 2 === 0 ? '20px' : '0px'})`}
            style={{ borderRadius: '2px' }}
          />
        </div>
      )}
      <div style={{ display: 'flex', flex: '1 1 0' }}>
        {props.days.map((_, i) => (
          <div className={css.cell} data-user-cell-exist={Boolean(renderUsersCell)} key={i} />
        ))}
      </div>
    </div>
  )
}

export default SkeletonContentRow
